import { render, staticRenderFns } from "./DisclosureTravel.vue?vue&type=template&id=39ba8637&scoped=true&"
import script from "./DisclosureTravel.vue?vue&type=script&lang=ts&"
export * from "./DisclosureTravel.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureTravel.vue?vue&type=style&index=0&id=39ba8637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba8637",
  null
  
)

export default component.exports